export default __webpack_public_path__ + "tink_logo.png";